import ReduxProtectedGenericForm from './redux-protected-generic-form';

export default ReduxProtectedGenericForm;